export default {
  login: {
    title: 'QuBit Affiliate',
    subtitle: 'Welcome to QuBit Affiliate',
    usernamePlaceholder: 'Username/Email',
    mobilePlaceholder: 'Mobile',
    qrCodePlaceholder: 'QR Code',
    accountLogin: 'Account Login',
    mobileLogin: 'Mobile Login',
    qrCodeLogin: 'QR Code Login',
    smsPlaceholder: 'SMS Code',
    register: 'Register',
    sendCode: 'Send Code',
    scanQRCodeTip: 'Please scan the QR code with your mobile phone',
    backToLogin: 'Back to Login',
    passwordPlaceholder: 'Password',
    captchaPlaceholder: 'Captcha',
    verificationCodePlaceholder: 'Verification Code',
    mobileRequired: 'Please input your mobile!',
    qrCodeRequired: 'Please scan the QR code!',
    smsRequired: 'Please input your SMS code!',
    usernameRequired: 'Please input your username or mobile!',
    passwordRequired: 'Please input your password!',
    captchaRequired: 'Please input verification code!',
    captchaMismatch: 'Wrong verification code',
    captchaError: 'Invalid verification code',
    rememberMe: 'Remember me for 7 days',
    forgotPassword: 'Forgot',
    loginButton: 'Login',
    scanQrcode: 'Scan QR Code',
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed, please check your username and password!',
    emailSent: 'Verification code sent',
    processingToken: 'Logging in...',
  },
  common: {
    theme: {
      light: 'Light Mode',
      dark: 'Dark Mode'
    },
    language: {
      zh: '简体中文',
      en: 'English',
      zhTW: '繁体中文'
    },
    actions: {
      expand: 'Expand',
      collapse: 'Collapse',
      view: 'View',
      edit: 'Edit',
      delete: 'Delete',
      create: 'Create',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      reset: 'Reset',
      search: 'Search',
      export: 'Export',
      import: 'Import'
    },
    notification: 'Notification',
    search: 'Search',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    languageSwitch: 'Switch Language',
    settings: 'Settings',
    yes: 'Yes',
    no: 'No',
    edit: 'Edit',
    delete: 'Delete',
    create: 'Create',
    cancel: 'Cancel',
    save: 'Save',
    export: 'Export',
    unknown: 'Unknown',
    and: 'and',
    validation: {
      walletAddressError: 'Please enter a numeric ID.',
      numericOnlyError: 'This field must contain only numbers.'
    }
  },
  messages: {
    error: {
      networkError: 'Network error, please try again later',
      serverError: 'Server error, please try again later'
    }
  },
  register: {
    subtitle: 'Welcome to QuBit Affiliate',
    usernamePlaceholder: 'Username',
    mobilePlaceholder: 'Mobile Number',
    smsPlaceholder: 'SMS Code',
    emailPlaceholder: 'Email',
    emailCodePlaceholder: 'Verification Code',
    invalidEmail: 'Invalid Email',
    passwordPlaceholder: 'Password',
    confirmPasswordPlaceholder: 'Confirm Password',
    usernameRequired: 'Please input your username',
    mobileRequired: 'Please input your mobile number',
    smsRequired: 'Please input SMS code',
    emailRequired: 'Please input your email',
    codeRequired: 'Please input verification code',
    passwordRequired: 'Please input your password',
    confirmPasswordRequired: 'Please confirm your password',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordNotMatch: 'The two passwords do not match',
    agreement: 'I have read and agree to the',
    agreementLink: 'User Agreement',
    termLink: 'Terms of Use',
    privacyLink: 'Privacy Policy',
    agreementRequired: 'Please read and agree to the User Agreement.',
    cookiesPolicy: 'This site uses cookies to ensure the best user experience. These cookies are strictly necessary or essential for optmal functionality. By using this site, you agree to th cookie policy.',
    sendCode: 'Send Code',
    smsSent: 'Verification code sent',
    smsFailed: 'Failed to send verification code',
    emailSent: 'Verification code sent',
    emailFailed: 'Failed to send verification code',
    submit: 'Register',
    success: 'Registration successful',
    failed: 'Registration failed',
    backToLogin: 'Back to Login',
    inviteCodePlaceholder: "Enter Invite Code",
    inviteCodeRequired: "Invite code is required.",
    inviteCodeMaxLength: "Invite code must be 6 characters or less.",
    passwordRules: {
      minLength: `Password must be at least 8 characters`,
      maxLength: `Password must not exceed 20 characters`,
      requireNumber: 'Password must contain numbers',
      requireLower: 'Password must contain lowercase letters',
      requireUpper: 'Password must contain uppercase letters',
      requireSpecial: 'Password must contain special characters'
    },
    passwordStrength: {
      veryWeak: 'Very Weak',
      weak: 'Weak',
      medium: 'Medium',
      strong: 'Strong',
      veryStrong: 'Very Strong'
    },
    passwordRequirements: {
      title: 'Password Requirements',
      length: 'Length must be between 8 and 20 characters',
      number: 'Must include numbers',
      upper: 'Must include uppercase letters',
      lower: 'Must include lowercase letters',
      special: 'Must include special characters'
    }
  },
  reset: {
    subtitle: 'Reset Your Password',
    mobilePlaceholder: 'Mobile Number',
    smsPlaceholder: 'SMS Code',
    newPasswordPlaceholder: 'New Password',
    confirmPasswordPlaceholder: 'Confirm Password',
    mobileRequired: 'Please input your mobile number',
    smsRequired: 'Please input SMS code',
    newPasswordRequired: 'Please input new password',
    confirmPasswordRequired: 'Please confirm your password',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordNotMatch: 'The two passwords do not match',
    sendCode: 'Send Code',
    smsSent: 'Verification code sent',
    smsFailed: 'Failed to send verification code',
    submit: 'Reset Password',
    success: 'Password reset successful',
    failed: 'Password reset failed',
    backToLogin: 'Back to Login'
  },
  profile: {
    basicInfo: 'Basic Information',
    security: 'Security Settings',
    activity: 'Account Activity',
    notification: 'Notifications',
    apiAccess: 'API Access',
    username: 'Username',
    email: 'Email',
    mobile: 'Mobile',
    gender: 'Gender',
    genderOptions: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    birthday: 'Birthday',
    location: 'Location',
    bio: 'Bio',
    company: 'Company',
    position: 'Position',
    website: 'Website',
    uploadAvatar: 'Upload Avatar',
    cropAvatar: 'Crop Avatar',
    avatarTypeError: 'You can only upload JPG/PNG files',
    avatarSizeError: 'Image must be smaller than 2MB',
    avatarUpdateSuccess: 'Avatar updated successfully',
    avatarUpdateFailed: 'Failed to update avatar',
    save: 'Save',
    validation: {
      usernameRequired: 'Please enter username',
      usernameFormat: 'Username can only contain letters, numbers and underscores, length 3-20',
      emailRequired: 'Please enter email',
      emailFormat: 'Please enter a valid email',
      mobileRequired: 'Please enter mobile number',
      mobileFormat: 'Please enter a valid mobile number',
      bioMaxLength: 'Bio cannot exceed 200 characters',
      websiteFormat: 'Please enter a valid URL'
    },
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    changePassword: 'Change Password',
    updateSuccess: 'Update successful',
    updateFailed: 'Update failed',
    passwordChanged: 'Password changed successfully',
    passwordChangeFailed: 'Failed to change password',
    invalidMobile: 'Please enter a valid mobile number',
    twoFactor: 'Two-Factor Authentication',
    loginDevices: 'Login Devices',
    notificationSettings: 'Notification Settings',
    loginHistory: 'Login History',
    operationLog: 'Operation Log',
    apiTokens: 'API Tokens',
    webhooks: 'Webhooks',
    loginDays: 'Login Days',
    lastActive: 'Last Active',
    deviceInfo: {
      browser: 'Browser',
      os: 'Operating System',
      ip: 'IP Address',
      location: 'Location',
      time: 'Login Time'
    },
    notificationTypes: {
      all: 'All Notifications',
      system: 'System',
      security: 'Security',
      activity: 'Activity'
    },
    apiTokenSettings: {
      create: 'Create Token',
      name: 'Token Name',
      token: 'Token',
      permissions: 'Permissions',
      expiresAt: 'Expires At',
      lastUsed: 'Last Used',
      created: 'Created',
      status: 'Status',
      active: 'Active',
      expired: 'Expired',
      revoked: 'Revoked'
    },
    webhookSettings: {
      create: 'Create Webhook',
      url: 'Callback URL',
      secret: 'Secret',
      events: 'Event Types',
      status: 'Status',
      lastDelivery: 'Last Delivery',
      deliveryStatus: 'Delivery Status'
    }
  },
  user: {
    profile: 'Profile',
    logout: 'Logout',
    defaultName: 'User'
  },
  route: {
    home: 'Home',

    dataAnalysis: 'Data Analysis',
    'dataAnalysis.dataOverview': 'Data Overview',
    'dataAnalysis.dailyDataAnalysis': 'Daily Data Analysis',

    customerManagement: 'Customer Management',
    'customerManagement.clientList': 'Client List',
    'customerManagement.clientGrouping': 'Client Grouping',
    'customerManagement.superAgentSystem': 'Super Agent System',
    'customerManagement.operationRecord': 'Operation Record',

    invitationPromotion: 'Invitation Promotion',
    'invitationPromotion.invitationLink': 'Invitation Link',
    'invitationPromotion.customRegistrationPage': 'Custom Registration Page',
    'invitationPromotion.invitationReviewRecord': 'Operation Record',

    financialDetails: 'Financial Details',
    'financialDetails.commission': 'Commission Details',
    'financialDetails.transaction': 'Transaction Details',
    'financialDetails.daily': 'Daily Data Summary',

    supportCenter: 'Support Center',
    'supportCenter.materialLibrary': 'Material Library Management',
    'supportCenter.helpCenter': 'Help Center',

    activityCenter: 'Activity Center',

    overview: 'Overview',

    system: 'System',
    'system.user': 'User Management',
    'system.role': 'Role Management',
    'system.menu': 'Menu Management',
    'system.dept': 'Department Management',
    
    network: 'Network',
    'network.basic': 'Basic Network',
    'network.advanced': 'Advanced Network',
    
    profile: 'Profile',
    'profile.basic': 'Basic Profile',
    'profile.advanced': 'Advanced Profile',
    
    error: 'Error',
    'error.403': '403',
    'error.404': '404',
    'error.500': '500',
    'error.network-error': 'Network error, please check network connection',
    
    auth: 'Auth',
    'auth.login': 'Login',
    'auth.register': 'Register',
    'dataChart': 'Data Chart',
    'chart': 'Data Table', // 添加这一行
  },
  network:{
    'network-error': 'Network error, please check network connection',
    'bad-request': '400 Bad Request',
    'unauthorized': '401 Unauthorized',
    'forbidden': '403 Forbidden',
    'not-found': '404 Not Found',
    'internal-error': '500 Internal Server Error',
    'request-canceled-or-timeout': 'Request canceled or timeout'
  },
  apiError: {
    '1001': 'System busy',
    '1002': 'Service temporarily unavailable',
    '1003': 'Request parameter error',
    '1004': 'Signature verification failed',
    '1005': 'Request time exception',
    '1006': 'Invalid action, please refresh and try again',
    '1007': 'Data not found',
    '1008': 'Database error',
    '1009': 'Verification code incorrect',
    '1010': 'Verification code expired, please get a new one',
    '1011': 'Captcha code error',
    '1012': 'Request frequent',
    '1013': 'Action timeout, please try again',
    '1014': 'Unsupported time interval (max 7 days)',
    '1015': 'Export limit exceeded (max 3 weeks)',
    '1101': 'Login not allowed',
    '1102': 'Incorrect username or password',
    '1103': 'Password login only for current user',
    '1104': 'Google Authenticator binding required',
    '1105': 'Invalid authenticator code',
    '1106': 'User does not exist',
    '1107': 'Two-step verification required',
    '1108': 'Permission denied, please change default password first',
    '1109': 'Access denied',
    '1110': 'User status error',
    '1111': 'Target user is a subordinate, move not allowed',
    '1112': 'System busy with other operations, please try later',
    '1113': 'Invalid ID or User ID not a subordinate',
    '1114': 'Reward ratio exceeds limit',
    '1115': 'Login expired',
    '1116': 'Settlement in progress, please try again later',
    '1117': 'Duplicate parameters',
    '1118': 'Cannot lower reward ratio',
    '1119': 'Invalid Token',
    '1120': 'Reward ratio cannot be lower than or equal to standard rate',
  },
  overview: {
    title: 'Data Overview',
    dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
    overview: 'Data Overview',
    totalCommission: 'Total Commission (USDT)',
    totalCommissionTooltip: 'Total commission',
    time: 'Time',
    month: 'Month',
    customer: 'Customer',
    selfRebate: 'Self Rebate',
    netFee: 'Net Fee',
    totalVolume: 'Total Volume (USDT)', 
    totalVolumeNote: '*This value includes all users under the agent, including direct and indirect users',
    customerCount: 'Customers (People)',
    customerCountNote: '*This value includes all users under the agent, including direct and indirect users',
    comparison: 'Comparison',
    hello: 'Hello, {name}!',
    spot: 'Spot',
    futures: 'Futures',
    alpha: 'Alpha',
    pendingWithdraw: 'Pending Withdrawal',
    withdraw: 'Withdraw',
    claim: 'Claim',
    customerActivity: 'Customer Activity',
    customerActivityNote: '*This value includes all users under the agent, including direct and indirect users',
    activeUsers: 'Daily Active Users',
    inactiveUsers: 'Inactive Users',
    myReferralLinks: 'My Referral Links',
    inviteCode: 'Invite Code',
    inviteeCount: 'Invitee Count',
    spotRebateRate: 'Spot Rebate Rate',
    futuresRebateRate: 'Futures Rebate Rate',
    alphaRebateRate: 'Alpha Rebate Rate',
    operation: 'Operation',
    myCommission: 'My',
    customerCommission: 'Customer',
    defaultLink: 'Default Link',
    shareLink: 'Share Link',
    recentRegistrations: 'Recent Registrations',
    recentRegistrationsNote: 'This data only includes directly referred users',
    userUID: 'User UID',
    registrationTime: 'Registration Time',
    isDeposited: 'Is Deposited',
    isActive: 'Is Active',
    yes: 'Yes',
    no: 'No',
    notifications: {
      userReward: 'User ***{id}*** received {amount} USDT reward'
    },
    noInviteCode: 'No invite code',
    noRecentRegistrations: 'No recent registration data',
    errorLoadingData: 'Error loading data:',
    claimError: 'Error claiming commission',
    loadingOverviewData: 'Loading overview data...',
    loadingRecentRegistrations: 'Loading recent registrations...',
    codeCopied: 'Invite code copied to clipboard',
    linkCopied: 'Referral link copied to clipboard',
  },
  dataAnalysis: {
    dataOverview: {
      title: 'Commission details',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      productLine: 'Product Line',
      subAgentUID: 'SubAgent UID',
      pleaseEnterPlaceholder: 'Please enter',
      invitationCode: 'Invitation Code',
      transactionTime: 'Transaction Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      export: 'Export',
      reset: 'Reset',
      query: 'Query',
      all: 'All',
      futures: 'Futures Trading',
      spot: 'Spot Trading',
      none: 'None',
      of: 'of',
      items: 'items',
      table: {
        subAgentContributionRanking: 'Sub-agent Contribution Ranking',
        invitationCodeContributionRanking: 'Invitation Code Contribution Ranking',
        rank: 'Rank',
        subAgentUID: 'Sub-agent UID',
        contributionCommission: 'Contribution Commission (USDT)',
        transactionAmount: 'Transaction Amount (USDT)',
        invitationCode: 'Invitation Code',
        registrationsCount: 'Registrations Count'
      },
      line: {
        title: 'Data Trend Analysis',
        commission: 'Commission',
        totalTransactionVolume: 'Total Transaction Volume',
        numberOfInvitees: 'Number of Invites',
        numberOfDeposits: 'Number of Depositors',
        newUserTrend: 'New User Trend',
        commissionTrend: 'Commission Trend'
      }
    },
    dailyDataAnalysis: {
      title: 'Daily Data Analysis',
      productLine: 'Product Line',
      transactionTime: 'Transaction Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      reset: 'Reset',
      query: 'Query',
      all: 'All',
      futures: 'Futures Trading',
      spot: 'Spot Trading',
      of: 'of',
      items: 'items',
      none: 'None',
      table: {
        date: 'Date',
        newUsers: 'New Users',
        activeUsers: 'Active Users',
        totalDeposits: 'Total Deposits',
        totalTradingVolume: 'Total Trading Volume',
        totalFees: 'Total Fees',
        totalCommission: 'Total Commission'
      }
    }
  },
  customerManagement: {
    clientList: {
      title: 'Client List',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      customerDetails: 'Customer Details',
      customerUID: 'Customer UID',
      customerEmail: 'Email / Wallet Address',
      superiorAgent: 'Superior Agent',
      pleaseEnterPlaceholder: 'Please enter',
      customerGroup: 'Customer Type',
      customerType: 'Customer Type',
      transactionTime: 'Transaction Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      reset: 'Reset',
      query: 'Query',
      all: 'All',
      clientListTable: 'Client List',
      totalRecords: 'records',
      selected: 'selected',
      of: 'of',
      items: 'items',
      none: 'None',
      direct: 'Direct',
      indirect: 'Indirect',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      addAgentError: 'Error adding agent.',
      manageError: 'Error managing client.',
      remarkError: 'Error editing remark.',
      detailsError: 'Error fetching details.',
      historyError: 'Error fetching history.',
      entrustType: {
        market: 'Market Order',
        limit: 'Limit Order',
        liquidation: 'Liquidation Order'
      },
      orderType: {
        marketOrder: 'Market Order',
        planOrder: 'Plan Order',
        takeProfitOrder: 'Take Profit Order',
        stopLossOrder: 'Stop Loss Order',
        forcedLiquidationOrder: 'Forced Liquidation Order'
      },
      direction: {
        buy: 'Buy',
        sell: 'Sell'
      },
      role: {
        maker: 'Maker',
        taker: 'Taker'
      },
      status: {
        default: 'Default',
        userRevocation: 'User Canceled',
        marketUnfilledRevocation: 'Market Price Unfilled Canceled',
        backgroundRevocation: 'System Canceled',
        full: 'Fully Filled',
        partialRetracted: 'Partially Filled and Canceled',
        partialSlot: 'Partially Filled'
      },
      table: {
        uid: 'UID',
        label: 'Remark',
        registrationTime: 'Registration Time',
        customerType: 'Customer Type',
        superiorAgentUID: 'Superior Agent UID',
        username: 'Username',
        tradingVolume: 'Trading Volume (USDT)',
        handlingFee: 'Handling Fee (USDT)',
        commissions: 'Commissions (USDT)',
        deposit: 'Deposit (USDT)',
        associatedGroup: 'Associated Group',
        assetRange: 'Asset Range (USDT)',
        firstDepositTime: 'First Deposit Time',
        firstLastTransactionTime: 'First/Last Transaction Time',
        firstTransactionTime: 'First Transaction Time',
        lastTransactionTime: 'Last Transaction Time',
        operation: 'Operation',
        view: 'View',
        manage: 'Manage',
        history: 'Historical Commission',
        futures: 'Futures',
        spot: 'Spot',
        transactionUID: 'Transaction UID',
        transactionMethod: 'Transaction Method',
        tradingPair: 'Trading Pair',
        direction: 'Direction',
        subjectiveMethod: 'Subjective Method',
        averageTransactionPrice: 'Average Transaction Price',
        executedOrderedVolume: 'Executed / Ordered Volume',
        transactionFee: 'Transaction Fee',
        orderStatus: 'Order Status',
        creationTime: 'Creation Time',
        addAgent: 'Add Agent',
        remark: 'Remark',
        active: 'Active',
        inactive: 'Inactive',
        registrationTimeTooltip: 'Active: Last transaction within 7 days. Inactive: No transaction in the last 7 days.'
      },
      manage: {
        title: 'Manage Clients',
        clientUID: 'Client UID',
        clientLabel: 'Client Label',
        clientLabelPlaceholder: 'Enter label',
        commissionSettings: 'Set Commission Ratio',
        spot: 'Spot',
        futures: 'Futures',
        clientRatio: 'Client Ratio',
        myRatio: 'My Ratio',
        modifyNote: 'Note: Changes to the initial commission ratios will make this client your agent.',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      addAgent: {
        title: 'Add as Agent',
        commissionSettings: 'Set Commission Ratios',
        confirm: 'Add as Agent'
      },
      remark: {
        title: 'Edit Remark',
        label: 'Remark',
        placeholder: 'Enter Remark',
        confirm: 'Save Remark'
      },
      details: {
        title: 'Basic Information',
        spot: 'Spot Rebate Ratio',
        futures: 'Futures Rebate Ratio',
        alpha: 'Alpha Rebate Ratio',
        customerType: 'Customer Type',
        directClient: 'Direct',
        indirectClient: 'Indirect',
        superiorAgentUID: 'Superior Agent UID',
        group: 'Group Name',
        none: 'None',
        registrationTime: 'Registration Time'
      }
    },
    clientGroup: {
      title: 'Client Grouping',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      groupName: 'Group Name',
      pleaseEnterGroupNamePlaceholder: 'Please enter group name',
      creationTime: 'Creation Time',
      queryTime: 'Query Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      totalRecords: 'records',
      selected: 'selected',
      of: 'of',
      items: 'items',
      none: 'None',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      createSuccess: 'Created successfully.',
      createError: 'Error creating.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      table: {
        dataList: 'Data List',
        addGroup: 'Add Group',
        groupId: 'Group ID',
        groupName: 'Group Name',
        creationTime: 'Creation Time',
        memberCount: 'Members',
        spotRatio: 'Spot Ratio',
        futuresRatio: 'Futures Ratio',
        depositorCount: 'Depositors',
        totalDeposit: 'Total Deposit (USDT)',
        totalVolume: 'Total Transaction Volume (USDT)',
        totalCommission: 'Total Commission (USDT)',
        operation: 'Operation',
        manage: 'Manage',
      },
      create: {
        addTitle: 'Add New Group',
        manageTitle: 'Manage Group',
        groupName: 'Group Name',
        groupNameMaxLength: 'Up to 12 characters',
        commissionSettings: 'Set Commission Ratio',
        spot: 'Spot',
        futures: 'Futures',
        alpha: 'Alpha',
        clientRatio: 'Client Ratio',
        myRatio: 'My Ratio',
        newUser: 'New User',
        selected: 'Selected',
        people: ' people',
        notAvailable: 'Not available',
        pleaseEnterCustomerUID: 'Please enter the customer UID',
        noMember: 'No member selected',
        cancel: 'Cancel',
        confirm: 'Confirm'
      }
    },
    superAgent: {
      title: 'Super Agent System',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      superAgentUID: 'Super Agent UID',
      pleaseEnterPlaceholder: 'Please enter',
      customerGroup: 'Customer Group',
      transactionTime: 'Transaction Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      reset: 'Reset',
      query: 'Query',
      all: 'All',
      none: 'None',
      of: 'of',
      items: 'items',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      createSuccess: 'Created successfully.',
      createError: 'Error creating.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      table: {
        superAgentUID: 'Super Agent UID',
        timeToBecomeSuperAgent: 'Onboarding Time', // 'Time to Become a Super Agent',
        invitationCode: 'Invitation Code',
        registrationTime: 'Registration Time',
        totalInvites: 'Total Invites',
        agentCount: 'Agent Count',
        rebateRatio: 'Rebate Ratio',
        operation: 'Operation',
        manage: 'Manage'
      },
      manage: {
        addTitle: 'Add Super Agent',
        manageTitle: 'Modify Super Agent',
        UID: 'UID',
        username: 'Username',
        usernamePlaceholder: 'Set username or remark',
        commissionSettings: 'Set Commission Ratio',
        spot: 'Spot',
        futures: 'Futures',
        alpha: 'Alpha',
        clientRatio: 'Client Ratio',
        myRatio: 'My Ratio',
        cancel: 'Cancel',
        confirm: 'Confirm'
      }
    }
  },
  invitationPromotion: {
    invitationLink: {
      title: 'Invitation Link',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      searchQuery: 'Search query',
      code: 'Invitation Code',
      pleaseEnterPlaceholder: 'Please enter the invitation code or note',
      promotionChannel: 'Promotion channel',
      all: 'All',
      dataStatisticsTime: 'Data statistics time',
      startTime: 'Start time',
      endTime: 'End time',
      reset: 'Reset',
      query: 'Query',
      totalRecords: 'records',
      selected: 'selected',
      of: 'of',
      items: 'items',
      none: 'None',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      table: {
        code: 'Invitation Code',
        default: 'Default',
        custom: 'Custom Registration Page',
        spot: 'Spot Rebate Ratio',
        futures: 'Futures Rebate Ratio',
        alpha: 'Alpha Rebate Ratio',
        linkLocation: 'Link Location',
        clickCount: 'Click Count',
        registrationCount: 'Number of Registrations',
        depositCount: 'Number of Deposits',
        tradeCount: 'Number of Trades',
        tradingVolume: 'Trading Volume (USDT)',
        rebateAmount: 'Rebate Amount (USDT)',
        operation: 'Operation',
        settings: 'Settings',
        shareLink: 'Share link'
      },
      share: {
        title: 'Invite Friends',
        yourCode: 'Your code is',
        whatsapp: 'WhatsApp',
        line: 'LINE',
        telegram: 'Telegram',
        twitter: 'Twitter',
        facebook: 'Facebook',
        shareMessage: 'Invite friends to join QuBit and earn rewards',
        copySuccess: 'Link copied to clipboard',
        copySuccessMsg: 'Link copied to clipboard',
        copyFailed: 'Copy link failed',
        copyFailedMsg: 'Copy link failed, please copy manually',
        bindSuccess: 'Binding successful',
        bindFailed: 'Failed to bind referral code',
        requestFailed: 'Request failed',
        shareTitle: 'Share Referral Link'
      },
      settings: {
        title: 'Link details',
        invitationLink: 'Invitation link',
        spot: 'Spot',
        futures: 'Futures',
        alpha: 'Alpha',
        web3: 'Web3',
        link: 'Invitation Link',
        code: 'Invitation Code',
        registrationType: 'Registration Page Type',
        remarks: 'Remarks',
        remarksPlaceholder: 'Please enter remarks',
        dataOverview: 'Data overview',
        rebateAmount: 'Rebate Amount (USDT)',
        tradingVolume: 'Trading Volume (USDT)',
        numberOfClicks: 'Number of Clicks',
        numberOfInvites: 'Number of Invites',
        numberOfTraders: 'Number of Traders',
        numberOfDepositors: 'Number of Depositors',
        modifyRebateRatio: 'Modify Rebate Ratio',
        changeInvitationCode: 'Change Invitation Code',
        editRegistrationType: 'Edit Registration Page Type',
        customRegistrationPage: 'Custom Registration Page',
        notSelected: 'Not Selected',
        cancel: 'Cancel',
        confirm: 'Confirm'
      }
    },
    registration: {
      title: 'Custom registration page',
      create: 'Create registration page',
      edit: 'Edit registration page',
      totalRecords: 'records',
      selected: 'selected',
      of: 'of',
      items: 'items',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      table: {
        name: 'Registration Page Name',
        validity: 'Page Validity Period',
        to: 'to',
        creationTime: 'Page Creation Time',
        linkCount: 'Number of Invitation Links',
        profileInfo: 'Profile Information',
        status: 'Status',
        default: 'Default Registration Page',
        operation: 'Operation',
        edit: 'Edit',
        yes: 'Yes',
        no: 'No'
      },
      custom: {
        title: 'Create Registration Page',
        name: 'Registration Page Name',
        registrationPageNamePlaceholder: 'Please enter the registration page name',
        showPersonalInfo: 'Show personal information',
        hidePersonalInfo: 'Hide personal information',
        upload: 'Upload',
        namePlaceholder: 'Please enter the name',
        introduction: 'Introduction',
        introductionPlaceholder: 'Please enter no more than 100 characters in Chinese and no more than 200 characters in English.',
        recommendedImageMaterials: 'Recommended image materials',
        default: 'Default',
        noImage: 'No image',
        platformStrength: 'Platform strength',
        transactionRebate: 'Transaction rebate',
        manyBenefits: 'Many benefits',
        thoughtfulService: 'Thoughtful service',
        eventImage: 'Event image',
        recommendedSize: '(Recommended: 560 * 300)',
        // upload
        validity: 'Page validity period (choose one of two)',
        longTermEffective: 'Long-term effective',
        customTime: 'Custom time',
        start: 'Start Time',
        end: 'End Time',
        eventLink: 'Event link',
        eventLinkPlaceholder: 'Please enter',
        cancel: 'Cancel',
        create: 'Create',
        confirm: 'Confirm'
      }
    },
    review: {
      title: 'Operation Record',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      customerUID: 'Customer UID',
      pleaseEnterPlaceholder: 'Please enter customer UID',
      type: 'Type',
      invitationLink: 'Invitation link',
      reset: 'Reset',
      query: 'Query',
      add: 'Add Agent',
      modify: 'Modify Agent',
      groupUpsert: 'Group Upsert',
      groupMemberUpsert: 'Group Member Upsert',
      topAgentAdd: 'Add Top Agent',
      all: 'All',
      totalRecords: 'records',
      selected: 'selected',
      of: 'of',
      items: 'items',
      none: 'None',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      walletAddressError: 'Please enter a numeric Customer UID.',
      customerUIDNumericError: 'Customer UID must contain only numbers.',
      invalidCustomerUID: 'Invalid Customer UID format.',
      table: {
        submissionTime: 'Submission Time',
        customerUID: 'Customer UID',
        type: 'Type',
        spot: 'Spot Rebate Ratio',
        futures: 'Futures Rebate Ratio',
        alpha: 'Alpha Rebate Ratio',
        confirmationTime: 'Confirmation Time',
        status: 'Status',
        reason: 'Reason for Failure',
        operation: 'Operation',
        viewDetails: 'View details'
      }
    }
  },
  financialDetails: {
    commission: {
      title: 'Commission details',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      customerUID: 'Customer UID',
      customerPlaceholder: 'Please enter customer UID',
      orderID: 'Order ID',
      orderIDPlaceholder: 'Please enter order ID',
      rebateType: 'Rebate type',
      all: 'All',
      transactionTime: 'Transaction time',
      startTime: 'Start time',
      endTime: 'End time',
      tradingPair: 'Trading pair',
      transactionMethod: 'Transaction method',
      buy: 'Buy',
      sell: 'Sell',
      reset: 'Reset',
      query: 'Query',
      none: 'None',
      cumulativeCommission: 'Cumulative commission',
      spot: 'Spot',
      futures: 'Futures',
      alpha: 'Alpha',
      of: 'of',
      items: 'items',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      exportSuccess: 'Data exported successfully!',
      noDataToExport: 'No data to export.',
      exportError: 'Export failed. Please try again.',
      table: {
        customerUID: 'Customer UID',
        remark: 'Remark',
        orderID: 'Order ID',
        customerGroup: 'Customer Group',
        associatedAgent: 'Associated Agent',
        superiorAgentUID: 'Superior Agent UID',
        tradingPair: 'Trading Pair',
        rebateRate: 'Rebate Rate',
        rebateAmount: 'Rebate Amount',
        rebateTime: 'Rebate Time',
        transactionMethod: 'Transaction Method',
        depositStatus: 'Posting Status'
      },
      depositStatusOptions: {
        unsettled: 'Unsettled',
        pending: 'Pending',
        completed: 'Completed',
        cancelled: 'Cancelled',
        frozen: 'Frozen'
      },
      rebateOptions: {
        spot: 'Spot',
        futures: 'Futures',
        alpha: 'Alpha'
      }
    },
    transaction: {
      title: 'Transaction details',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone)',
      customerUID: 'Customer UID',
      customerPlaceholder: 'Please enter customer UID',
      superiorAgentUID: 'Superior agent UID',
      superiorAgentPlaceholder: 'Please enter superior agent UID',
      tradingPair: 'Trading pair',
      all: 'All',
      groupName: 'Group name',
      default: 'Default',
      role: 'Role',
      maker: 'Maker',
      taker: 'Taker',
      transactionTime: 'Transaction time',
      startTime: 'Start time',
      endTime: 'End time',
      transactionMethod: 'Transaction method',
      buy: 'Buy',
      sell: 'Sell',
      reset: 'Reset',
      query: 'Query',
      none: 'None',
      cumulativeTradingVolume: 'Cumulative trading volume (USDT)',
      cumulativeTransactionFees: 'Cumulative transaction fees (USDT)',
      spot: 'Spot',
      futures: 'Futures',
      alpha: 'Alpha',
      of: 'of',
      items: 'items',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      exportSuccess: 'Data exported successfully!',
      noDataToExport: 'No data to export.',
      exportError: 'Export failed. Please try again.',
      table: {
        customerUID: 'Customer UID',
        remark: 'Remark',
        orderID: 'Order ID',
        email: 'Email',
        handlingFee: 'Handling Fee',
        group: 'Group',
        superiorAgentUID: 'Superior Agent UID',
        transactionTime: 'Transaction Time',
        tradingPair: 'Trading Pair',
        transactionVolume: 'Transaction Volume',
        netFee: 'Net Fee',
        transactionMethod: 'Transaction Method',
        operationAmount: 'Operation Amount'
      }
    },
    daily: {
      title: 'Daily Data Summary',
      dataUpdatedAt: 'Data updated at: {time} (UTC+8 timezone) *Data updated T+1',
      timeRange: 'Time Range',
      startTime: 'Start time',
      endTime: 'End time',
      none: 'None',
      of: 'of',
      items: 'items',
      copySuccess: 'Copied successfully.',
      copyError: 'Error copying.',
      fetchError: 'An error occurred while fetching data.',
      groupFetchError: 'An error occurred while fetching group list.',
      modifyDirectOnly: 'You can only modify the client ratio of direct customers.',
      modifyRatioIncreaseOnly: 'You can only increase the ratios.',
      modifySuccess: 'Saved successfully.',
      modifyError: 'Error modifying.',
      exportSuccess: 'Data exported successfully!',
      noDataToExport: 'No data to export.',
      exportError: 'Export failed. Please try again.',
      table: {
        date: 'Date',
        totalCommission: 'Total Commission',
        totalTransactionAmount: 'Total Transaction Amount',
        netHandlingFee: 'Net Handling Fee',
        newInvitedPeopleCount: 'New Invited People Count'
      }
    }
  }
}
